import Image from './Image';
customElements.define('core-file-input-image', Image,{extends: 'div'});

import Video from './Video';
customElements.define('core-file-input-video', Video,{extends: 'div'});

import File from './File';
customElements.define('core-file-input-file', File,{extends: 'div'});

import MultipleFiles from './MultipleFiles';
customElements.define('core-file-input-multiple-files', MultipleFiles,{extends: 'div'});